import { useNavigationCheckpoints } from "neetocommons/react-utils/useRegisterNavigationCheckpoint";
import { NavLink } from "react-router-dom";

const CheckPointNavLinks = ({
  checkpointKey,
  to,
  href,
  children,
  ...others
}) => {
  const { [checkpointKey]: checkpoint } =
    useNavigationCheckpoints(checkpointKey);

  const LinkElement = href ? "a" : NavLink;
  const linkProps = href
    ? { href, key: href, ...others }
    : { to: checkpoint || to, key: to, ...others };

  return <LinkElement {...linkProps}>{children}</LinkElement>;
};

export default CheckPointNavLinks;
